@if (showDivider) {
  <nz-divider [nzText]="adresses" nzOrientation="center">
    <ng-template #adresses>
      <h5>{{ 'PERSONAL_DATA_FORM.RESIDENCE_ADDRESS_IN_POLAND' | translate }}</h5>
    </ng-template>
  </nz-divider>
}

<div class="row">
  <div class="nowrap-container">
    @if (controls.residenceStreet; as residenceStreet) {
      <div class="standard-form-field widened-field residenceStreet-field required-field">
        <label for="applicantResidenceStreet" [class.invalid]="residenceStreet.touched && residenceStreet.invalid">
          {{ 'PERSONAL_DATA_FORM.RESIDENCE-STREET.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-form-field appearance="outline">
          <input
            matInput
            id="applicantResidenceStreet"
            type="text"
            maxLength="200"
            minLength="1"
            placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-STREET.PLACEHOLDER' | translate }}"
            [required]="true"
            [attr.aria-required]="true"
            [attr.aria-describedby]="
              residenceStreet.touched && residenceStreet.invalid
                ? 'residenceStreetError residenceStreetTooltip'
                : 'residenceStreetTooltip'
            "
            [attr.aria-invalid]="residenceStreet.touched && residenceStreet.invalid ? 'true' : null"
            [formControl]="residenceStreet" />
          <app-cr-form-field-tooltip
            [id]="'residenceStreetTooltip'"
            class="info-suffix-icon"
            matSuffix
            [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
          </app-cr-form-field-tooltip>
          @if (residenceStreet.touched && residenceStreet.invalid) {
            <mat-error id="residenceStreetError">
              {{ residenceStreet.errors | errorsFormatingAndTranslate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    }
    @if (controls.residenceHouseNumber; as residenceHouseNumber) {
      <div class="standard-form-field residenceHouseNumber-field required-field">
        <label
          for="applicantResidenceHouseNumber"
          [class.invalid]="residenceHouseNumber.touched && residenceHouseNumber.invalid">
          {{ 'PERSONAL_DATA_FORM.RESIDENCE-HOUSE-NUMBER.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-form-field appearance="outline">
          <input
            matInput
            id="applicantResidenceHouseNumber"
            type="text"
            maxLength="20"
            minLength="1"
            placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-HOUSE-NUMBER.PLACEHOLDER' | translate }}"
            [required]="true"
            [attr.aria-required]="true"
            [attr.aria-describedby]="
              residenceHouseNumber.touched && residenceHouseNumber.invalid
                ? 'residenceHouseNumberError residenceHouseNumberTooltip'
                : 'residenceHouseNumberTooltip'
            "
            [attr.aria-invalid]="residenceHouseNumber.touched && residenceHouseNumber.invalid ? 'true' : null"
            [formControl]="residenceHouseNumber" />
          <app-cr-form-field-tooltip
            [id]="'residenceHouseNumberTooltip'"
            class="info-suffix-icon"
            matSuffix
            [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
          </app-cr-form-field-tooltip>
          @if (residenceHouseNumber.touched && residenceHouseNumber.invalid) {
            <mat-error id="residenceHouseNumberError">
              {{ residenceHouseNumber.errors | errorsFormatingAndTranslate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    }
  </div>
  <div class="nowrap-container">
    @if (controls.residenceApartmentNumber; as residenceApartmentNumber) {
      <div class="standard-form-field residenceApartmentNumber-field">
        <label
          for="applicantResidenceApartmentNumber"
          [class.invalid]="residenceApartmentNumber.touched && residenceApartmentNumber.invalid">
          {{ 'PERSONAL_DATA_FORM.RESIDENCE-APARTMENT-NUMBER.MAIN-LABEL' | translate }}
        </label>
        <mat-form-field appearance="outline">
          <input
            matInput
            id="applicantResidenceApartmentNumber"
            type="text"
            maxLength="20"
            minLength="1"
            placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-APARTMENT-NUMBER.PLACEHOLDER' | translate }}"
            [required]="false"
            [attr.aria-required]="false"
            [attr.aria-describedby]="
              residenceApartmentNumber.touched && residenceApartmentNumber.invalid
                ? 'residenceApartmentNumberError residenceApartmentNumberTooltip'
                : 'residenceApartmentNumberTooltip'
            "
            [attr.aria-invalid]="residenceApartmentNumber.touched && residenceApartmentNumber.invalid ? 'true' : null"
            [formControl]="residenceApartmentNumber" />
          <app-cr-form-field-tooltip
            [id]="'residenceApartmentNumberTooltip'"
            class="info-suffix-icon"
            matSuffix
            [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
          </app-cr-form-field-tooltip>
          @if (residenceApartmentNumber.touched && residenceApartmentNumber.invalid) {
            <mat-error id="residenceApartmentNumberError">
              {{ residenceApartmentNumber.errors | errorsFormatingAndTranslate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    }
  </div>
</div>

<div class="additional-border" [class.border-enabled]="mode === 'employee'">
  <div class="row extra-margin">
    <div class="nowrap-container">
      @if (controls.residenceCity; as residenceCity) {
        <div class="standard-form-field widened-field residenceCity-field required-field">
          <label for="applicantResidenceCity" [class.invalid]="residenceCity.touched && residenceCity.invalid">
            {{ 'PERSONAL_DATA_FORM.RESIDENCE-CITY.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantResidenceCity"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-CITY.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-describedby]="
                residenceCity.touched && residenceCity.invalid
                  ? 'residenceCityError residenceCityTooltip'
                  : 'residenceCityTooltip'
              "
              [attr.aria-invalid]="residenceCity.touched && residenceCity.invalid ? 'true' : null"
              [formControl]="residenceCity" />
            <app-cr-form-field-tooltip
              [id]="'residenceCityTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>
            @if (residenceCity.touched && residenceCity.invalid) {
              <mat-error id="residenceCityError">
                {{ residenceCity.errors | errorsFormatingAndTranslate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
      @if (controls.residencePostalCode; as residencePostalCode) {
        <div class="standard-form-field residencePostalCode-field required-field">
          <label
            for="applicantResidencePostalCode"
            [class.invalid]="residencePostalCode.touched && residencePostalCode.invalid">
            {{ 'PERSONAL_DATA_FORM.RESIDENCE-POSTAL-CODE.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantResidencePostalCode"
              type="text"
              inputmode="numeric"
              mask="00-000"
              [keepCharacterPositions]="true"
              [clearIfNotMatch]="true"
              [showMaskTyped]="true"
              [dropSpecialCharacters]="true"
              maxLength="12"
              minLength="5"
              placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-POSTAL-CODE.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-describedby]="
                residencePostalCode.touched && residencePostalCode.invalid
                  ? 'residencePostalCodeError residencePostalCodeTooltip'
                  : 'residencePostalCodeTooltip'
              "
              [attr.aria-invalid]="residencePostalCode.touched && residencePostalCode.invalid ? 'true' : null"
              [formControl]="residencePostalCode" />
            <app-cr-form-field-tooltip
              [id]="'residencePostalCodeTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>
            @if (residencePostalCode.touched && residencePostalCode.invalid) {
              <mat-error id="residencePostalCodeError">
                {{ residencePostalCode.errors | errorsFormatingAndTranslate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
    </div>
    <div class="nowrap-container">
      @if (controls.residenceVoivodeshipDetailsId; as residenceVoivodeshipDetailsId) {
        <div class="standard-form-field residenceVoivodeshipName-field required-field">
          <label
            id="applicantResidenceVoivodeshipNameLabel"
            [class.invalid]="residenceVoivodeshipDetailsId.touched && residenceVoivodeshipDetailsId.invalid">
            {{ 'PERSONAL_DATA_FORM.RESIDENCE-VOIVODESHIP-NAME.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          @if (voivodeships$ | async; as voivodeships) {
            <mat-form-field appearance="outline">
              <mat-select
                [formControl]="residenceVoivodeshipDetailsId"
                id="applicantResidenceVoivodeshipName"
                aria-labelledby="applicantResidenceVoivodeshipNameLabel"
                panelClass="['standard-select', longer-select']"
                placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-VOIVODESHIP-NAME.PLACEHOLDER' | translate }}"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-invalid]="
                  residenceVoivodeshipDetailsId.touched && residenceVoivodeshipDetailsId.invalid ? 'true' : null
                "
                [attr.aria-describedby]="
                  residenceVoivodeshipDetailsId.touched && residenceVoivodeshipDetailsId.invalid
                    ? 'residenceVoivodeshipDetailsIdError'
                    : null
                "
                (keydown.Tab)="onTab($event, trapVoivodeshipTab)">
                @for (voivo of voivodeships; track voivo) {
                  <mat-option [value]="voivo.id">
                    {{ 'COMMON.VOIVODESHIPS.' + voivo.key | translate }}
                  </mat-option>
                }
              </mat-select>
              @if (residenceVoivodeshipDetailsId.touched && residenceVoivodeshipDetailsId.invalid) {
                <mat-error id="residenceVoivodeshipDetailsIdError">
                  {{ residenceVoivodeshipDetailsId.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          }
        </div>
      }
      @if (lookingForVoivodeship) {
        <div
          [id]="voivodeshipSpinnerId"
          [class.loading-wrapper]="voivodeshipSpinnerClass === 'loading-wrapper'"
          role="status"
          aria-live="polite">
          <span class="sr-only">
            {{ 'COMMON.LAYOUT.LOADING' | translate }}
          </span>
          <mat-spinner [diameter]="voivodeshipSpinnerDiameter" [attr.aria-hidden]="true"> </mat-spinner>
        </div>
      }
    </div>
  </div>
  @if (mode === 'employee') {
    <div class="row">
      @if (controls.residenceDistrictId; as residenceDistrictId) {
        <div class="standard-form-field residenceDistrict-field">
          <label
            id="applicantResidenceDistrictIdLabel"
            [class.invalid]="residenceDistrictId.touched && residenceDistrictId.invalid">
            {{ 'COMMON.LABEL.DISTRICT' | translate }}
          </label>
          @if (districts$ | async; as districts) {
            <mat-form-field appearance="outline">
              <mat-select
                [formControl]="residenceDistrictId"
                [disabled]="!controls.residenceVoivodeshipDetailsId?.value"
                id="applicantResidenceDistrictId"
                aria-labelledby="applicantResidenceDistrictIdLabel"
                [panelClass]="['standard-select', 'longer-select']"
                [placeholder]="'COMMON.PLACEHOLDER.SELECT_DISTRICT' | translate"
                [attr.aria-required]="false"
                [attr.aria-disabled]="!controls.residenceVoivodeshipDetailsId?.value"
                [attr.aria-invalid]="residenceDistrictId.touched && residenceDistrictId.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  residenceDistrictId.touched && residenceDistrictId.invalid ? 'residenceDistrictIdError' : null
                "
                class="heightened-select">
                @if (loadingDistricts$ | async) {
                  <mat-option role="status" aria-live="polite">
                    <span class="sr-only">
                      {{ 'COMMON.LAYOUT.LOADING' | translate }}
                    </span>
                    <mat-spinner [diameter]="25" [attr.aria-hidden]="true"></mat-spinner>
                  </mat-option>
                }
                @for (district of districts; track district) {
                  <mat-option [value]="district.id">
                    {{ district.MOS_name.toUpperCase() }} ({{ district.MOS_extra_name.toUpperCase() }})
                  </mat-option>
                }
              </mat-select>
              @if (residenceDistrictId.touched && residenceDistrictId.invalid) {
                <mat-error id="residenceDistrictIdError">
                  {{ residenceDistrictId.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          }
        </div>
      }
      @if (controls.residenceMunicipalityId; as residenceMunicipalityId) {
        <div class="standard-form-field residenceMunicipality-field">
          <label
            id="applicantResidenceMunicipalityIdLabel"
            [class.invalid]="residenceMunicipalityId.touched && residenceMunicipalityId.invalid">
            {{ 'COMMON.LABEL.MUNICIPALITY' | translate }}
          </label>
          @if (municips$ | async; as municips) {
            <mat-form-field appearance="outline">
              <mat-select
                [formControl]="residenceMunicipalityId"
                [disabled]="!controls.residenceDistrictId?.value"
                id="applicantResidenceMunicipalityId"
                aria-labelledby="applicantResidenceMunicipalityIdLabel"
                [panelClass]="['standard-select', 'longer-select']"
                [placeholder]="'COMMON.PLACEHOLDER.SELECT_MUNICIPALITY' | translate"
                [attr.aria-required]="false"
                [attr.aria-disabled]="!controls.residenceDistrictId?.value"
                [attr.aria-invalid]="residenceMunicipalityId.touched && residenceMunicipalityId.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  residenceMunicipalityId.touched && residenceMunicipalityId.invalid
                    ? 'residenceMunicipalityIdError'
                    : null
                ">
                @if (loadingMunicips$ | async) {
                  <mat-option role="status" aria-live="polite">
                    <span class="sr-only">
                      {{ 'COMMON.LAYOUT.LOADING' | translate }}
                    </span>
                    <mat-spinner [diameter]="25" role="status" [attr.aria-hidden]="true"> </mat-spinner>
                  </mat-option>
                }
                @for (municip of municips; track municip) {
                  <mat-option [value]="municip.id">
                    {{ municip.MOS_name.toUpperCase() }} ({{ municip.MOS_type.toUpperCase() }})
                  </mat-option>
                }
              </mat-select>
              @if (residenceMunicipalityId.touched && residenceMunicipalityId.invalid) {
                <mat-error id="residenceMunicipalityIdError">
                  {{ residenceMunicipalityId.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          }
        </div>
      }
      @if (controls.residenceCityListedId; as residenceCityListedId) {
        <div class="standard-form-field residenceCityListed-field">
          <label
            id="applicantResidenceCityListedIdLabel"
            [class.invalid]="residenceCityListedId.touched && residenceCityListedId.invalid">
            {{ 'COMMON.LABEL.CITY_MOS' | translate }}
          </label>
          @if (cities$ | async; as cities) {
            <mat-form-field appearance="outline">
              <mat-select
                [formControl]="residenceCityListedId"
                [disabled]="!controls.residenceMunicipalityId?.value"
                id="applicantResidenceCityListedId"
                aria-labelledby="applicantResidenceCityListedIdLabel"
                [panelClass]="['standard-select', 'longer-select']"
                (keydown.Tab)="onTab($event, true)"
                [placeholder]="'COMMON.PLACEHOLDER.SELECT_CITY' | translate"
                [attr.aria-required]="false"
                [attr.aria-disabled]="!controls.residenceMunicipalityId?.value"
                [attr.aria-invalid]="residenceCityListedId.touched && residenceCityListedId.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  residenceCityListedId.touched && residenceCityListedId.invalid ? 'residenceCityListedIdError' : null
                ">
                @if (loadingCities$ | async) {
                  <mat-option role="status" aria-live="polite">
                    <span class="sr-only">
                      {{ 'COMMON.LAYOUT.LOADING' | translate }}
                    </span>
                    <mat-spinner [diameter]="25" role="status" [attr.aria-hidden]="true"></mat-spinner>
                  </mat-option>
                }
                @for (city of cities; track city) {
                  <mat-option [value]="city.id">
                    {{ city.MOS_name.toUpperCase() }}
                  </mat-option>
                }
              </mat-select>
              @if (residenceCityListedId.touched && residenceCityListedId.invalid) {
                <mat-error id="residenceCityListedIdError">
                  {{ residenceCityListedId.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          }
        </div>
      }
    </div>
  }
</div>

<div class="row">
  @if (voivoIsBeeingUsed && !userACKDocumentsReset) {
    <div
      class="zip-warning-overflow-container"
      [class.zip-warning-overflow-container--compact]="warningLayout === 'compact'">
      <h4 class="mat-h4">{{ 'PERSONAL_DATA_FORM.IF_YOU_CHANGE_VOIVO_DOCUMENTS_RESET' | translate }}</h4>
      <button
        mat-raised-button
        color="primary"
        (click)="voivoChangeAcknowledged.emit()"
        (keydown.Tab)="onTab($event, trapWarningButtonTab)">
        {{ 'APPLICATION.I_UNDERSTAND_AND_WANT_TO_PROCEED' | translate }}
      </button>
    </div>
  }
</div>

@if (controls.residenceLegalTitle; as residenceLegalTitle) {
  <div class="row">
    <div class="nowrap-container">
      <div class="standard-form-field widened-field residenceLegalTitle-field required-field">
        <label for="residenceLegalTitle" [class.invalid]="residenceLegalTitle.touched && residenceLegalTitle.invalid">
          {{ 'PERSONAL_DATA_FORM.RESIDENCE-LEGAL-TITLE.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-form-field appearance="outline">
          <input
            matInput
            id="residenceLegalTitle"
            type="text"
            maxLength="1000"
            minLength="1"
            placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-LEGAL-TITLE.PLACEHOLDER' | translate }}"
            [required]="true"
            [formControl]="residenceLegalTitle"
            [attr.aria-required]="true"
            [attr.aria-invalid]="residenceLegalTitle.touched && residenceLegalTitle.invalid ? 'true' : null"
            [attr.aria-describedby]="
              residenceLegalTitle.touched && residenceLegalTitle.invalid
                ? 'residenceLegalTitleError residenceLegalTitleTooltip'
                : 'residenceLegalTitleTooltip'
            "
            (keydown.Tab)="onTab($event, true)" />
          <app-cr-form-field-tooltip
            [id]="'residenceLegalTitleTooltip'"
            class="info-suffix-icon"
            matSuffix
            [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
          </app-cr-form-field-tooltip>
          @if (residenceLegalTitle.touched && residenceLegalTitle.invalid) {
            <mat-error id="residenceLegalTitleError">
              {{ residenceLegalTitle.errors | errorsFormatingAndTranslate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  </div>
}
